//React
import React from 'react';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';
import { withAlert } from 'react-alert';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myPhotoAction from '../action/myPhotoAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';

//Icon
import ClearIcon from '@material-ui/icons/Clear';
import { BsPersonSquare } from 'react-icons/bs';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CropIcon from '@material-ui/icons/Crop';
//Part
import PartDropZone from './PartDropZone';
import PartMainPhotoSample from './PartMainPhotoSample';
import PartImageUploadHelp from './PartImageUploadHelp';
//Dialog
import DialogImageCrop from './DialogImageCrop';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      originImage: null,
      uploadThumb: null,
      uploadSecret: false,
      uploadSubmitVisible: false,
      uploadProgress: null,
      restriction: 1,
      dialogImageCropVisible: false,
  	}
  }

  componentDidMount() {
    document.title = 'メイン写真の登録 - パートナーズ';
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.originImage !== this.state.originImage && this.state.originImage) {
      this._imageLoad(this.state.originImage);
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 1200).then((res) => {
      this.setState({uploadThumb:res.uri});
    }).catch((err) => {
      this.setState({uploadThumb:null});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(rotate) {
    let file = this.state.uploadThumb;
    await imageRotate(file, rotate).then((res) => {
      this.setState({uploadThumb:res.uri});
    })
  }


  _submit() {
    let imageBase64 = this.state.uploadThumb;
    let restriction = this.state.restriction;
    this.props.myPhotoMainAdd(imageBase64, restriction, () => {
      this.props.history.push('/new/end/');
    })
  }


	render() {
		return (
      <div style={{maxWidth:'480px', margin:'auto'}}>
        <h1 align='center'>
          メイン写真の登録
        </h1>
        <div style={{margin:'10px'}}>
          <ul style={{paddingLeft:'20px'}}>
            <li>メイン写真はプロフや検索に表示され、第一印象を決める最も重要な写真です。</li>
            <li>メイン写真を掲載している会員にだけ公開されます。</li>
            <li>メイン写真はいつでも削除、変更できます。</li>
          </ul>
        </div>

        <div style={{padding:'10px'}}>
          <PartMainPhotoSample />
        </div>


        <div style={{ margin:'20px 20px 0px 20px'}}>

            {
              (this.state.uploadThumb) ?
              <div>

                <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                  <div align='center' style={{padding:'5px', position:'relative'}}>
                    <img style={{ width:'160px', height:'160px', objectFit:'contain' }} src={this.state.uploadThumb} id='thumb' alt='' />
                  </div>
                  <IconButton
                    style={{position:'absolute', right:'0px', top:'0px'}}
                    onClick={ () => this.setState({uploadThumb: null}) }
                  >
                    <ClearIcon/>
                  </IconButton>
                </div>


                <div align='center'>
                  <Fab
                    color='inherit'
                    size='small'
                    onClick={ () => this._imageRotate('l')}
                  >
                    <RotateLeftIcon/>
                  </Fab>
                  &nbsp;
                  <Fab
                    color='inherit'
                    size='small'
                    onClick={ () => this._imageRotate('r')}
                  >
                    <RotateRightIcon/>
                  </Fab>
                  &nbsp;
                  <Fab
                    color='inherit'
                    size='small'
                    onClick={ () => this.setState({dialogImageCropVisible: true}) }
                  >
                    <CropIcon/>
                  </Fab>
                </div>

                <DialogImageCrop
                  originImage={this.state.originImage}
                  open={this.state.dialogImageCropVisible}
                  close={ () => this.setState({dialogImageCropVisible: false}) }
                  onSubmit={ (img) => this.setState({uploadThumb:img}) }
                />

                <div align='center' style={{padding:'10px'}}>
                  <Button
                    variant="contained"
                    color="secondary"
                    component="span"
                    onClick={ () => this._submit() }
                    startIcon={<CloudUploadIcon />}
                  >
                    <div style={{fontSize:'1.4em'}}>アップロード</div>
                  </Button>
                </div>
              </div>
              :
              <PartDropZone
                handleDrop={ (v) => this.setState({originImage:v}) }
                style={{position:'relative'}}
              >
                <div>
                  <div align='center' style={{padding:'10px'}}>
                    <label htmlFor="photo_file" style={{display:'block'}}>
                      <IconButton component="span">
                        <BsPersonSquare style={{fontSize:'4em'}}/>
                      </IconButton>
                    </label>

                    <label htmlFor="photo_file" style={{cursor:"pointer", display:'block'}}>
                      <Button variant="contained" color='primary' component="span">
                        <div>
                          <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                        </div>
                      </Button>
                    </label>

                  </div>
                </div>
              </PartDropZone>
            }
          <input
            type='file'
            id='photo_file'
            accept='image/*'
            onChange={ (e) => {
              this.setState({originImage:e.target.files[0]});
              e.target.value = null;
            }}
            style={{opacity:'0'}}
          />

          <div style={{padding:'5px'}} align='right'>
            <PartImageUploadHelp />
          </div>


        </div>

        <div align='right' style={{padding:'20px 10px 10px 0px'}}>
          <Button
            variant="outlined"
            onClick={ () => this.props.history.push('/new/end/') }
          >
            <span style={{fontSize:'1.1em'}}>今はメイン写真を登録しない</span>
          </Button>
        </div>
      </div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPhotoAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withAlert()(Comp));
